var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTooltip = function SvgTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#A4A4A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.237 4.395c.035-1.033.752-1.789 2.057-1.789 1.204 0 2.008.694 2.008 1.661 0 .672-.334 1.143-.931 1.499-.576.334-.739.562-.739 1.002v.254h-1.02l-.004-.312c-.04-.65.216-1.045.822-1.401.545-.33.73-.567.73-1.002 0-.466-.37-.805-.923-.805-.567 0-.932.348-.967.893zm1.899 4.693a.63.63 0 0 1-.642-.624c0-.347.286-.62.642-.62s.637.273.637.62a.627.627 0 0 1-.637.624"
  })));
};
export default SvgTooltip;